/* eslint-disable */
export const previewEsign = (data, previewmodal) => ({
  type: 'PREVIEW_ESIGN',
  data,
  previewmodal,
});
